import Axios from "axios"
import qs from "qs"
import { apiUrl} from './config';
let url = apiUrl;

//新生报到接口
export function getLoginId(module){
    let data = qs.stringify({
        m:"studentApi",
        t:"studentRecruit",
        c:"validate",
        sfzjh:module.idNum,
        xm:module.userName
    })
    return Axios.post(url,data).then(res=>{
        return Promise.resolve(res.data)
    })
}

//获取学生个人信息
export function getPersonInfo(module) {
    const data = {
        m:'studentApi',
        t:"studentRecruit",
        c:"getStuInfo",
        sfzjh:module.idNum,
        rid: module.rid,
    };
    return Axios(url, { params: data }).then(res => {
      return Promise.resolve(res.data)
    })
}
//修改个人信息
export function updatePersonInfo(module){
    const data = qs.stringify({
        m:'studentApi',
        t: "studentRecruit",
        c: "updateStuInfo",
        rid:module.rid,
        sfzjh:module.idNum,
        mobile:module.mobile,
        lydq:module.lydq,
        dalb:module.dalb,
        txdz:module.txdz,
        zzmm:module.zzmm,
        mz:module.mz,
        family_type:module.family_type,
        household_type:module.household_type,
        graduate_school:module.graduate_school,
        family_size:module.family_size,
        postal_code:module.postal_code,
        province_code_s: module.province_code_s,
        cityCode_s: module.cityCode_s,
        lydqdm_s: module.cityCode_s,
        lydqdm:module.lydqdm,
    });
    return Axios.post(url,data).then(res=>{
        return Promise.resolve(res.data)
    })
}
//获取专业列表信息
export function getProList(module){
    const data = {
        m:"studentApi",
        t:"studentRecruit",
        c:"getMajorByRid",
        rid:module.rid,
        sfzjh:module.idNum
    }
    return Axios(url,{params:data}).then(res=>{
        return Promise.resolve(res.data)
    })
}
//获取个人专业信息
export function getProfessInfo(module){
    const data = {
        m:'studentApi',
        t: "studentRecruit",
        c: "getCollegeMajor",
        sfzjh:module.idNum,
        rid:module.rid
    }
    return Axios(url,{ params : data }).then(res=>{
        return Promise.resolve(res.data)
    })
}
//更换专业申请
export function updateProfess(module){
    const data = qs.stringify({
        m:"studentApi",
        t:"studentRecruit",
        c:"majorApply",
        rid:module.rid,
        sfzjh:module.idNum,
        yxbm_major_id:module.yxbm_major_id,
        yxbm_id:module.yxbm_id,
        major_name:module.major_name,
        yxbm_name:module.yxbm_name,
        content:module.content,
        sch_id:1
    });
    return Axios.post(url,data).then(res=>{
        return Promise.resolve(res.data)
    })

}
//获取家属信息
export function getFamilyInfo(module){
    const data = {
        m:"studentApi",
        t:"studentRecruit",
        c:"getParentInfo",
        xs_sfzjh:module.idNum,
        rid:module.rid
    }
    return Axios(url,{params:data}).then(res=>{
        return Promise.resolve(res.data)
    })
}
//修改家属信息
export function updataFamilyInfo(module){
    const data = qs.stringify({
        m: "userApi",
        t: "userCenter",
        c:"updateParent",
        rid:module.rid,
        xs_sfzjh:module.xs_sfzjh,
        sch_id:module.sch_id,
        parent:module.parent,
        year_income:module.year_income,
        unemployment:module.unemployment,
        other_situation:module.other_situation,
        funding_situation:module.funding_situation,
        debt_situation:module.debt_situation,
        accident:module.accident
    })
    return Axios.post(url,data).then(res=>{
        return Promise.resolve(res.data)
    })
}
//获取宿舍信息
export function getRoomInfo(){
    const data = {
        m:"studentApi",
        t:"studentRecruit",
        c:"goods",
        sch_id:1,
    }
    return Axios.get(url,{params:data}).then(res=>{
        return Promise.resolve(res.data)
    })
}
//修改宿舍信息
export function updateRoom(module){
    const data = qs.stringify({
        m:"studentApi",
        t:"studentRecruit",
        c:"subDorm",
        rid:module.rid,
        sfzjh:module.idNum,
        is_dorm:module.is_dorm,
        is_buy:module.is_buy,
        buy_list:module.buy_list,
    });
    return Axios.post(url,data).then(res=>{
        return Promise.resolve(res.data)
    })
}
//缴费，延迟报到信息
export function getCostAndDelayInfo(module){
    const data = {
        m:"studentApi",
        t:"studentRecruit",
        c:"getApplyInfo",
        sfzjh:module.idNum,
        sch_id:module.sch_id,
        rid:module.rid
    }
    return Axios.get(url,{params:data}).then(res=>{
        return Promise.resolve(res.data)
    })
}
//获取头像
export function getImg(module){
    const data = {
        m:"studentApi",
        t:"studentRecruit",
        c:"headInfo",
        sfzjh:module.idNum,
        rid:module.rid
    }
    return Axios.get(url,{params:data}).then(res=>{
        return Promise.resolve(res.data)
    })
}
//宿舍物品信息列表
export function getRoomGoogs(module){
    const data = {
        m:"studentApi",
        t:"studentRecruit",
        c:"getdorm",
        sfzjh: module.sfzjh,
        id_type: 4,
        rid: module.rid,
        sch_id:1,
    };
    return Axios.get(url,{params:data}).then(res=>{
        return Promise.resolve(res.data)
    })
}
//延迟报到
export function delayInfo(module){
    const data = {
        m:"studentApi",
        t:"studentRecruit",
        c:"getApplyInfo",
        sfzjh:module.idNum,
        rid:module.rid,
        sch_id:module.sch_id,
        type:1,
    }
    return Axios.get(url,{params:data}).then(res=>{
        return Promise.resolve(res.data)
    })
}
//上传延迟报到图片
export function uploaddelayImg(module){
    const data = qs.stringify({
        m:"studentApi",
        t:"studentRecruit",
        c:"uploadApply",
        sfzjh:module.idNum,
        sch_id:module.sch_id,
        file:module.file,
        ident:module.ident,
    });
    return Axios.post(url,data).then(res=>{
        return Promise.resolve(res.data)
    })
}
//推迟入学申请
export function delayInSchool(module){
    const data = qs.stringify({
        m:"studentApi",
        t:"studentRecruit",
        c:"delayApply",
        rid:module.rid,
        sfzjh:module.idNum,
        resource_id:module.resource_id,
        sch_id:module.sch_id,
        delay_type:module.delay_type,
    });
    return Axios.post(url,data).then(res=>{
        return Promise.resolve(res.data)
    })
}


//类型
export function chooseCapacity(module) {
    let data = {
        t: 'chooseDorm',
        m: 'dormRegApi',
        c: 'chooseCapacity',
        sfzjh: module.sfzjh,
    }
    return Axios.get(url, { params: data }).then(res => {
        return Promise.resolve(res.data)
    })
}

//api.zhxy.czvtc.edu.cn/?t=chooseDorm&m=dormRegApi&sfzjh=MzYwMjIyMTk5MjEyMTM1NjEy&c=chooseDorm&is_bunk=2&capacity=6
//宿舍
export function chooseDorm(module) {
    let data = {
        t: 'chooseDorm',
        m: 'dormRegApi',
        c: 'chooseDorm',
        sfzjh: module.sfzjh,
        capacity: module.capacity
    }
    return Axios.get(url, { params: data }).then(res => {
        return Promise.resolve(res.data)
    })
}
//api.zhxy.czvtc.edu.cn/?t=chooseDorm&m=dormRegApi&sfzjh=MzYwMjIyMTk5MjEyMTM1NjEy&c=chooseDormBed&dorm_id=73

//床位号
export function chooseDormBed(module) {
    let data = {
        t: 'chooseDorm',
        m: 'dormRegApi',
        c: 'chooseDormBed',
        sfzjh: module.sfzjh,
        dorm_id: module.dorm_id,
    }
    return Axios.get(url, { params: data }).then(res => {
        return Promise.resolve(res.data)
    })
}

//住宿提交
export function dormBedApply(module) {
    let data = qs.stringify({
        t: 'chooseDorm',
        m: 'dormRegApi',
        c: 'dormBedApply',
        sfzjh: module.sfzjh,
        dorm_id: module.dorm_id,
        bed_id: module.bed_id
    })
    return Axios.post(url, data).then(res => {
        return Promise.resolve(res.data)
    })
}

//申请记录
export function getMyDorm(module) {
    let data = {
        t: 'chooseDorm',
        m: 'dormRegApi',
        c: 'getMyDorm',
        sfzjh: module.sfzjh,
    }
    return Axios.get(url, { params: data }).then(res => {
        return Promise.resolve(res.data)
    })
}

//修改宿舍信息
export function studetail(module) {
    let data = {
        t: 'studentRecruit',
        m: 'studentApi',
        c: 'studetail',
        sfzjh: Base64.encode(module.sfzjh) ,
    }
    return Axios.get(url, { params: data }).then(res => {
        return Promise.resolve(res.data)
    })
}


// WEBPACK FOOTER //
// ./src/api/login.js